import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { unregisterServiceWorker } from './unregisterServiceWorker';

import ErrorHandlerComponent from 'Components/ErrorHandler';
import { ErrorBoundary } from 'react-error-boundary';

import './_utils/polyfill';

import SentryService from '_services/Sentry';
import UADetector from 'Helper/UADetector';

SentryService.init();

const { isIPad, isIPhone } = UADetector();
if (isIPhone || isIPad) {
    document.body.classList.add('ios');
}

/**
 * Upgraded to React version 18.0.0
 */
const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);
// prettier-ignore
root.render(
    <StrictMode>
        <ErrorBoundary FallbackComponent={ErrorHandlerComponent}>
            <App />
        </ErrorBoundary>
    </StrictMode>
);

// The app is no longer a PWA: remove any service worker left over from
// a previous install so returning visitors get the current bundle.
unregisterServiceWorker();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
